export var onMultiple = function (reducer, actions, handler) {
    actions.forEach(function (action) {
        reducer.on(action, function (state, payload) {
            return handler(state, payload, action);
        });
    });
};
